/**
 * These constants are used elsewhere, but never defined. Adding them here
 * as undefined to stop console warnings. - Michael Stanaland, 10/9/2019
 */
export const RELOAD_MANAGED_CONCESSIONAIRES_SET = undefined;
export const RELOAD_MANAGED_COOPERATORS_SET = undefined;
export const SAVING_MANAGED_CONCESSIONAIRES_FAILED = undefined;

export const LOGGED_OUT = 'LOGGED_OUT';
export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const SET_EMAIL = 'SET_EMAIL';
export const DISPLAY_AUTO_LOGOUT_WARNING = 'DISPLAY_AUTO_LOGOUT_WARNING';
export const CLOSE_AUTO_LOGOUT_WARNING = 'CLOSE_AUTO_LOGOUT_WARNING';
export const LOGGED_OUT_FOR_INACTIVITY = 'LOGGED_OUT_FOR_INACTIVITY';
export const LOGGED_OUT_FOR_MUST_SET_PASSWORD = 'LOGGED_OUT_FOR_MUST_SET_PASSWORD';
export const LOGGED_OUT_FOR_MUST_RESET_PASSWORD = 'LOGGED_OUT_FOR_MUST_RESET_PASSWORD';

export const VALIDATE_SUCCESSFUL = 'VALIDATE_SUCCESSFUL';
export const PASSWORD_RESET = 'PASSWORD_RESET';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
export const RECOVER_PASSWORD_SUCCESSFUL = 'RECOVER_PASSWORD_SUCCESSFUL';
export const RECOVER_PASSWORD_FAILED = 'RECOVER_PASSWORD_FAILED';
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED';
export const CHANGE_PASSWORD_SUCCESSFUL = 'CHANGE_PASSWORD_SUCCESSFUL';
export const CHANGE_PASSWORD_CANCELED = 'CHANGE_PASSWORD_CANCELED';
export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED';
export const FOUND_NEW_USER = 'FOUND_NEW_USER';

export const NAVIGATE_USERS_MANAGER = 'NAVIGATE_USERS_MANAGER';
export const NAVIGATE_INVENTORY_MANAGER = 'NAVIGATE_INVENTORY_MANAGER';
export const NAVIGATE_RESERVATION_MANAGER = 'NAVIGATE_RESERVATION_MANAGER';
export const NAVIGATE_LINK_MANAGER = 'NAVIGATE_LINK_MANAGER';

export const FETCH_USERS_CLEAR = 'FETCH_USERS_CLEAR';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILED = 'FETCH_USERS_FAILED';
export const THROTTLE_USER_LIST = 'THROTTLE_USER_LIST';

export const FETCH_USER_NOTES_SUCCESS = 'FETCH_USER_NOTES_SUCCESS';
export const FETCH_USER_NOTES_FAILED = 'FETCH_USER_NOTES_FAILED';
export const ADD_NOTE_FAILED = 'ADD_NOTE_FAILED';
export const STORE_NOTE_FOR_CREATE = 'STORE_NOTE_FOR_CREATE';
export const NOTE_ADDED_FOR_EXISTING_USER = 'NOTE_ADDED_FOR_EXISTING_USER';

export const ACCOUNT_SAVED = 'ACCOUNT_SAVED';
export const CANCEL_UPDATE = 'CANCEL_UPDATE';
export const CREATING_USER = 'CREATING_USER';
export const CREATING_CONCESSIONAIRE_USER = 'CREATING_CONCESSIONAIRE_USER';
export const EDITING_USER = 'EDITING_USER';
export const SAVE_FAILED = 'SAVE_FAILED';
export const ASSIGN_LOCATION = 'ASSIGN_LOCATION';
export const DELETE_LOCATION = 'DELETE_LOCATION';
export const CANCEL_ASSIGNING_LOCATIONS = 'CANCEL_ASSIGNING_LOCATIONS';
export const CONTINUE_FROM_ASSIGNING_LOCATIONS = 'CONTINUE_FROM_ASSIGNING_LOCATIONS';
export const LOADING_MANAGED_LOCATIONS_SUCCESSFUL = 'LOADING_MANAGED_LOCATIONS_SUCCESSFUL';
export const LOADING_MANAGED_LOCATIONS_FAILED = 'LOADING_MANAGED_LOCATIONS_FAILED';
export const ASSIGN_CONCESSIONAIRE = 'ASSIGN_CONCESSIONAIRE';
export const DELETE_CONCESSIONAIRE = 'DELETE_CONCESSIONAIRE';
export const CANCEL_ASSIGNING_CONCESSIONAIRES = 'CANCEL_ASSIGNING_CONCESSIONAIRES';
export const CONTINUE_FROM_ASSIGNING_CONCESSIONAIRES = 'CONTINUE_FROM_ASSIGNING_CONCESSIONAIRES';
export const CONTINUE_FROM_CREATING_USER = 'CONTINUE_FROM_CREATING_USER';
export const ROLE_ASSIGNED = 'ROLE_ASSIGNED';
export const ROLE_DELETED = 'ROLE_DELETED';
export const ROLE_DELETE_FAILED = 'ROLE_DELETE_FAILED';
export const USER_DELETED = 'USER_DELETED';
export const USER_DELETE_FAILED = 'USER_DELETE_FAILED';
export const UPDATING_ROLES_SUCCESSFUL = 'UPDATING_ROLES_SUCCESSFUL';
export const SETTING_DEFAULT_ROLE_SUCCESSFUL = 'SETTING_DEFAULT_ROLE_SUCCESSFUL';
export const REQUEST_CONFIRM_STATUS = 'REQUEST_CONFIRM_STATUS';
export const RESET_CONFIRM_STATUS = 'RESET_CONFIRM_STATUS';
export const RESET_RESET_STATUS = 'RESET_RESET_STATUS';
export const GET_USER_FAILED = 'GET_USER_FAILED';
export const GETTING_USER = 'GETTING_USER';

export const RELOAD_MANAGE_CONCESSIONAIRE_ERRORS = 'RELOAD_MANAGE_CONCESSIONAIRE_ERRORS';
export const LOADING_MANAGED_CONCESSIONAIRES_SUCCESSFUL = 'LOADING_MANAGED_CONCESSIONAIRES_SUCCESSFUL';
export const LOADING_MANAGED_CONCESSIONAIRES_FAILED = 'LOADING_MANAGED_CONCESSIONAIRES_FAILED';
export const LOADING_CONCESSIONAIRE_PERMITS_SUCCESSFUL = 'LOADING_CONCESSIONAIRE_PERMITS_SUCCESSFUL';
export const LOADING_CONCESSIONAIRE_PERMITS_FAILED = 'LOADING_CONCESSIONAIRE_PERMITS_FAILED';
export const SAVING_CONCESSIONAIRE_SUCCESSFUL = 'SAVING_CONCESSIONAIRE_SUCCESSFUL';
export const SAVING_CONCESSIONAIRE_FAILED = 'SAVING_CONCESSIONAIRE_FAILED';
export const SAVING_CONCESSIONAIRE_PERMIT_SUCCESSFUL = 'SAVING_CONCESSIONAIRE_PERMIT_SUCCESSFUL';
export const SAVING_CONCESSIONAIRE_PERMIT_FAILED = 'SAVING_CONCESSIONAIRE_PERMIT_FAILED';
export const SET_MANAGED_CONCESSIONAIRE = 'SET_MANAGED_CONCESSIONAIRE';
export const SET_CONCESSIONAIRE_PERMIT = 'SET_CONCESSIONAIRE_PERMIT';

export const RELOAD_MANAGE_COOPERATOR_ERRORS = 'RELOAD_MANAGE_COOPERATOR_ERRORS';
export const LOADING_MANAGED_COOPERATORS_SUCCESSFUL = 'LOADING_MANAGED_COOPERATORS_SUCCESSFUL';
export const LOADING_MANAGED_COOPERATORS_FAILED = 'LOADING_MANAGED_COOPERATORS_FAILED';
export const LOADING_COOPERATOR_EMPLOYEES_SUCCESSFUL = 'LOADING_COOPERATOR_EMPLOYEES_SUCCESSFUL';
export const LOADING_COOPERATOR_EMPLOYEES_FAILED = 'LOADING_COOPERATOR_EMPLOYEES_FAILED';
export const SAVING_MANAGED_COOPERATORS_SUCCESSFUL = 'SAVING_MANAGED_COOPERATORS_SUCCESSFUL';
export const SAVING_MANAGED_COOPERATORS_FAILED = 'SAVING_MANAGED_COOPERATORS_FAILED';
export const SAVING_COOPERATOR_SUCCESSFUL = 'SAVING_COOPERATOR_SUCCESSFUL';
export const SAVING_COOPERATOR_FAILED = 'SAVING_COOPERATOR_FAILED';
export const SAVING_COOPERATOR_EMPLOYEES_SUCCESSFUL = 'SAVING_COOPERATOR_EMPLOYEES_SUCCESSFUL';
export const SAVING_COOPERATOR_EMPLOYEES_FAILED = 'SAVING_COOPERATOR_EMPLOYEES_FAILED';
export const SAVING_EMPLOYEE_SUCCESSFUL = 'SAVING_EMPLOYEE_SUCCESSFUL';
export const DELETING_MANAGED_COOPERATORS_SUCCESSFUL = 'DELETING_MANAGED_COOPERATORS_SUCCESSFUL';
export const DELETING_MANAGED_COOPERATORS_FAILED = 'DELETING_MANAGED_COOPERATORS_FAILED';
export const DELETING_COOPERATOR_SUCCESSFUL = 'DELETING_COOPERATOR_SUCCESSFUL';
export const DELETING_COOPERATOR_EMPLOYEES_SUCCESSFUL = 'DELETING_COOPERATOR_EMPLOYEES_SUCCESSFUL';
export const DELETING_COOPERATOR_EMPLOYEES_FAILED = 'DELETING_COOPERATOR_EMPLOYEES_FAILED';
export const DELETING_EMPLOYEE_SUCCESSFUL = 'DELETING_EMPLOYEE_SUCCESSFUL';
export const SET_MANAGED_COOPERATOR = 'SET_MANAGED_COOPERATOR';
export const SET_COOPERATOR_EMPLOYEE = 'SET_COOPERATOR_EMPLOYEE';
export const GET_ASSIGNED_CONCESSIONAIRES_SUCCESS = 'GET_ASSIGNED_CONCESSIONAIRES_SUCCESS';
export const GET_ASSIGNED_CONCESSIONAIRES_FAILED = 'GET_ASSIGNED_CONCESSIONAIRES_FAILED';
export const FETCH_ASSIGNABLE_CONCESSIONAIRE_PERMIT_SUCCESSFUL = 'FETCH_ASSIGNABLE_CONCESSIONAIRE_PERMIT_SUCCESSFUL';
export const FETCH_ASSIGNABLE_CONCESSIONAIRE_PERMIT_FAILED = 'FETCH_ASSIGNABLE_CONCESSIONAIRE_PERMIT_FAILED';

export const CONFIRM_EMAIL_SUCCESS = 'CONFIRM_EMAIL_SUCCESS';
export const CONFIRM_EMAIL_FAILED = 'CONFIRM_EMAIL_FAILED';

export const SET_SELECTED_TAB_INDEX = 'SET_SELECTED_TAB_INDEX';
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION';

export const START_LOADING = 'START_LOADING';
export const DONE_LOADING = 'DONE_LOADING';

export const ALERTS_FETCHED = 'ALERTS_FETCHED';
export const FETCHING_ALERTS_FAILED = 'FETCHING_ALERTS_FAILED';

export const FETCH_DOMAINS_FOR_LOCATION_SUCCESS = 'FETCH_DOMAINS_FOR_LOCATION_SUCCESS';
export const FETCH_DOMAINS_FOR_LOCATION_ERROR = 'FETCH_DOMAINS_FOR_LOCATION_ERROR';
export const FETCH_DOMAINS_FOR_ROLES_SUCCESS = 'FETCH_DOMAINS_FOR_ROLES_SUCCESS';

export const ENABLING_PASSWORD_RESET_FAILED = 'ENABLING_PASSWORD_RESET_FAILED';
export const ENABLING_PASSWORD_RESET_SUCCESS = 'ENABLING_PASSWORD_RESET_SUCCESS';

export const FETCH_FACILITY_INFO_SUCCESS = 'FETCH_FACILITY_INFO_SUCCESS';
export const FETCH_FACILITY_INFO_ERROR = 'FETCH_FACILITY_INFO_ERROR';
export const UPDATE_FACILITY_POC = 'UPDATE_FACILITY_POC';
export const SET_FACILITY_POC_ERROR = 'SET_FACILITY_POC_ERROR';
export const CLEAR_FACILITY_POC_ERROR = 'CLEAR_FACILITY_POC_ERROR';
export const UPDATE_FACILITY_NOTE_SUCCESS = 'UPDATE_FACILITY_NOTE_SUCCESS';
export const ADD_FACILITY_NOTE_ERROR = 'ADD_FACILITY_NOTE_ERROR';
export const CLEAR_FACILITY_NOTE_ERRORS = 'CLEAR_FACILITY_NOTE_ERRORS';
export const INT_FEEDBACK_SUCCESS = 'INT_FEEDBACK_SUCCESS';
export const INT_FEEDBACK_FAILED = 'INT_FEEDBACK_FAILED';
export const SET_FACILITY_MODAL_RESULT = 'SET_FACILITY_MODAL_RESULT';
export const SET_FACILITY_FLAG_SUCCESS = 'SET_FACILITY_FLAG_SUCCESS';
export const SET_FACILITY_FLAG_ERROR = 'SET_FACILITY_FLAG_ERROR';
export const START_LOCATION_ENTRANCE_REQUEST = 'START_LOCATION_ENTRANCE_REQUEST';
export const LOCATION_ENTRANCE_REQUEST_ERROR = 'LOCATION_ENTRANCE_REQUEST_ERROR';
export const LOCATION_ENTRANCE_REQUEST_SUCCESS = 'LOCATION_ENTRANCE_REQUEST_SUCCESS';

export const FETCH_ATTESTATION_START = 'FETCH_ATTESTATION_START';
export const FETCH_ATTESTATION_SUCCESS = 'FETCH_ATTESTATION_SUCCESS';
export const FETCH_ATTESTATION_FAILURE = 'FETCH_ATTESTATION_FAILURE';
export const FETCH_ATTESTATION_RESET = 'FETCH_ATTESTATION_RESET';
export const POST_ATTESTATION_START = 'POST_ATTESTATION_START';
export const POST_ATTESTATION_SUCCESS = 'POST_ATTESTATION_SUCCESS';
export const POST_ATTESTATION_FAILURE = 'POST_ATTESTATION_FAILURE';
export const ATTESTATION_STATE = 'ATTESTATION_STATE';

// OLD KILL //
export const LOADING_CONCESSIONAIRE_PERMIT_DETAILS_SUCCESSFUL = 'LOADING_CONCESSIONAIRE_PERMIT_DETAILS_SUCCESSFUL';
export const LOADING_CONCESSIONAIRE_PERMIT_DETAILS_FAILED = 'LOADING_CONCESSIONAIRE_PERMIT_DETAILS_FAILED';
export const GET_CONCESSIONAIRE_SUCCESS = 'GET_CONCESSIONAIRE_SUCCESS';
export const GET_CONCESSIONAIRE_FAILED = 'GET_CONCESSIONAIRE_FAILED';
// OLD //

export const USER_SEARCH_FIELD_CHANGED = 'USER_SEARCH_FIELD_CHANGED';
export const USER_SEARCH_VALUE_CHANGED = 'USER_SEARCH_VALUE_CHANGED';
export const USER_SEARCH_FILTER_CHANGED = 'USER_SEARCH_FILTER_CHANGED';

export const LOCATION_CHANGE = 'IA_ROUTING_LOCATION_CHANGE';

export const FETCH_FEATURE_FLAGS_SUCCESS = 'FETCH_FEATURE_FLAGS_SUCCESS';
export const FETCH_FEATURE_FLAGS_FAILED = 'FETCH_FEATURE_FLAGS_FAILED';

export const concessionaireHierarchyTypes = {
  START: 'HIERARCHY_START',
  ADD: 'HIERARCHY_ADD',
  ERROR: 'HIERARCHY_ERROR',
  END: 'HIERARCHY_END',
};
